import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_MULTI_FOR_MULTI_QUERY = graphql(/* GraphQL */ `
	query discountMultiForMulti($hotelID: String!, $discountId: String!, $discountListHotelId2: ID!) {
		discountMulti(hotelID: $hotelID, discountID: $discountId) {
			hotelID
			discountID
			discountCode
			inSale
			name
			description
			isUncancelable
			saleTypeForPlan
			saleTypeForTerm
			saleStart
			saleEnd
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
			multiDiscounts
			discountPriceTotalLimit {
				currencyType
				amount
			}
		}
		discountList(hotelID: $discountListHotelId2) {
			longTerm {
				id
				name
				discountID
			}
			ordinary {
				id
				name
				discountID
			}
		}
	}
`);
